import React from 'react';
import {
  Edit,
  ListButton,
  TopToolbar,
  useNotify,
  useRefresh,
} from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import PersonForm from './PersonForm';
import { errors, thereWasProblem } from '../../Utils/messages';

const PersonActions = ({ basePath }: { basePath: string }) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const PersonEdit = (props: any) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const onFailure = (error: string) => {
    refresh();
    notify(
      `${thereWasProblem}: ${error || 'Hubo un error con su solicitud, inténtelo mas tarde...'}`,
      'warning'
    );
  };

  return (
    <Edit
      actions={<PersonActions {...props} />}
      onFailure={onFailure}
      {...props}
    >
      <PersonForm />
    </Edit>
  );
};

export default PersonEdit;
